module.exports = __webpack_public_path__ + "img/my-sales.fa3a5111.svg";